import { useEffect } from "react";
import { css } from "@emotion/react";

import { CommentItem } from "../atoms";

import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { fadeInVariants } from "../../constants/animations";

export type CastModalProps = {
  open: boolean;
  close: () => void;
  imgPath: string;
  castImgPath: string;
  castImgSize: number;
  castImgSizeSP: number;
  cbImgPath: string;
  comment: string;
  profile: string;
};

const CastModal: React.FC<CastModalProps> = (props) => {
  const {
    open,
    close,
    imgPath,
    castImgPath,
    castImgSize,
    castImgSizeSP,
    cbImgPath,
    comment,
    profile,
  } = props;

  // cast image
  const castImgControls = useAnimation();
  const [castImgRef, castImgInView] = useInView();
  useEffect(() => {
    if (castImgInView) {
      castImgControls.start("visible");
    }
  }, [castImgInView]);

  // comment item
  const commentItemControls = useAnimation();
  const [commentItemRef, commentItemInView] = useInView();
  useEffect(() => {
    if (commentItemInView) {
      commentItemControls.start("visible");
    }
  }, [commentItemInView]);

  // cb img
  const cbImgControls = useAnimation();
  const [cbImgRef, cbImgInView] = useInView();
  useEffect(() => {
    if (cbImgInView) {
      cbImgControls.start("visible");
    }
  }, [cbImgInView]);

  return open ? (
    <div css={mainStyle}>
      <div css={containerWrapperStyle}>
        <img
          src={process.env.REACT_APP_BASE_PATH + "/img/close-btn.png"}
          onClick={close}
          css={closeBtnStyle}
        />
        <div css={contentsWrapperStyle}>
          <motion.div
            css={castWrapperStyle}
            ref={castImgRef}
            initial="hidden"
            animate={castImgControls}
            variants={fadeInVariants}
          >
            <img
              src={process.env.REACT_APP_BASE_PATH + imgPath}
              css={castImgWrapperStyle}
            />
            <img
              src={process.env.REACT_APP_BASE_PATH + castImgPath}
              css={castNameImgStyle(castImgSize, castImgSizeSP)}
            />
          </motion.div>
          <motion.div
            css={css`
              display: flex;
              justify-content: center;
            `}
            ref={commentItemRef}
            initial="hidden"
            animate={commentItemControls}
            variants={fadeInVariants}
          >
            <CommentItem
              comment={comment}
              profile={profile}
              wrapperStyle={commentItemStyle(70, 30)}
            />
          </motion.div>
          <motion.img
            src={process.env.REACT_APP_BASE_PATH + cbImgPath}
            css={cbImgStyle}
            ref={cbImgRef}
            initial="hidden"
            animate={cbImgControls}
            variants={fadeInVariants}
          />
        </div>
      </div>
    </div>
  ) : null;
};

const spSize = 768;

const mainStyle = css`
  position: fixed;
  overflow-y: scroll;
  top: 0;
  left: 0;
  z-index: 100;
  background-image: url(${process.env.REACT_APP_BASE_PATH +
  "/img/tumblr_back.webp"});
  background-size: cover;
  width: 100%;
  height: 100vh;
`;

const closeBtnStyle = css`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 30px;
  height: 30px;

  &:hover {
    cursor: pointer;
  }
`;

const containerWrapperStyle = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const contentsWrapperStyle = css`
  margin-top: 120px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: ${spSize}px) {
    margin-bottom: 0;
  }
`;

const castWrapperStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const castImgWrapperStyle = css`
  position: relative;
  width: 350px;
  height: auto;
  overflow: hidden;

  @media (max-width: ${spSize}px) {
    width: 240px;
  }
`;

const castImgStyle = css`
  width: 100%;
  height: auto;
`;

const castNameImgStyle = (width: number, widthSP: number) => css`
  margin-top: 12px;
  width: ${width}px;

  @media (max-width: ${spSize}px) {
    width: ${widthSP}px;
  }
`;

const commentItemStyle = (marginTop: number, marginTopSP: number) => css`
  max-width: 800px;
  margin-top: ${marginTop}px;
  background-color: #28485a;

  @media (max-width: ${spSize}px) {
    max-width: 80%;
    margin-top: ${marginTopSP}px;
  }
`;

const cbImgStyle = css`
  width: 80%;
  max-width: 600px;
  height: auto;
  margin-top: 80px;

  @media (max-width: ${spSize}px) {
    width: 100vw;
  }
`;

export default CastModal;
